<template>
  <div>
    <el-card>
      <div slot="header" class="clearfix">
        <span style="color: #409EFF">账户提现</span>
      </div>

      <el-form ref="queryForm" :model="queryForm" label-width="260px">
        <el-row :gutter="5" align="center">
          <el-col :span="24">
            <el-form-item label="请选择收款信息" prop="payBack">
              <el-select v-model="queryForm.b2cBackCardId" clearable placeholder="请选择收款信息">
                <el-option
                    v-for="item in backOptions"
                    :key="item.id"
                    :label="item.backCardName+' '+item.backCardNum"
                    :value="item.id"
                >
                </el-option>
              </el-select>
              <span class="el-icon-plus" style="margin-left: 2px;"><router-link
                  to="/home/businbackcardm">添加支付信息</router-link></span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="提现金额" prop="investMoney">
              <el-input v-model="queryForm.cashOutMoney" placeholder="输入金额"></el-input>
              <span>可提现<span style="color: red">{{queryForm.cashInsidMoney}}</span>金</span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20" v-show="isOpenPayPassword">
          <el-col :span="12">
            <el-form-item label="提现密码" prop="investMoney">
              <el-input v-model="queryForm.cashPassword" type="password" placeholder="输入密码"></el-input>
              <el-button type="text" @click="setOrResetPwd">设置或重置取现密码</el-button>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12" align="center">
            <el-button @click="submitCashOut()" size="mini" type="primary">提交取现申请</el-button>
          </el-col>
        </el-row>
        <el-row :gutter="20" style="text-align: left; margin: 10px;margin-left: 15%;">
          <el-col :span="24" align="left">
            <el-row :gutter="20" style="margin: 10px" v-if="cashOutPromptStr!=null">
              <el-col :span="20">
                <span>{{cashOutPromptStr}}</span>
              </el-col>
            </el-row>
            <el-row :gutter="20" style="margin: 10px">
              <el-col :span="20">
                <span>1金=1元 ,<span style="color: #4481eb;font-size: medium">{{cashOutLimitMoney!=null?cashOutLimitMoney:0.00}}</span>金起提 ,一天只能申请一次  </span>
              </el-col>
            </el-row>
            <el-row :gutter="20" style="margin: 10px">
              <el-col :span="20">
                <span>当提现金额低于<span style="color: #4481eb;font-size: medium">{{cashOutLimitMoney!=null?cashOutLimitMoney:0.00}}</span>元,请联系管理员,获取提现帮助。 </span>
              </el-col>
            </el-row>
            <el-row :gutter="20" style="margin: 10px">
              <el-col :span="20">
                <span>本平台杜绝一切洗钱行为，一经发现报警处理并冻结资金，用多少充多少，请勿随意提现！谢谢合作</span>
              </el-col>
            </el-row>
            <el-row :gutter="20" style="margin: 10px">
              <el-col :span="20">
                <span>本站只支持支付宝充值和提现 </span>
              </el-col>
            </el-row>
          </el-col>
        </el-row>
      </el-form>
    </el-card>
    <customer-service-component></customer-service-component>
  </div>
</template>

<script>
import MixinCUD from '@/components/MixinCUD';
import {getAllB2cBackCard} from "../../api/b2cbusiness/b2c_backcardmanage";
import {
  commitCashOutMoney,
  queryCashOutLimitMoney,
  queryCashOutPromptStr,
  queryUserMoney
} from "../../api/b2cbusiness/b2c_admin";
import CustomerServiceComponent from "../../components/CustomerServiceComponent";

export default {
  name: "ApplyCashOutm",
  components:{CustomerServiceComponent,},
  mixins: [MixinCUD],
  data() {
    return {
      cashOutPromptStr:null,
      queryFormRefName:"queryForm",
      queryForm: {
        payPassword: "",
        cashInsidMoney: "32037.68",
        cashOutMoney: ""
      },
      cashOutLimitMoney:null,
      isOpenPayPassword:false,
      backOptions:[]
    }
  },
  mounted() {
    let that = this;
    getAllB2cBackCard().then(res=>{
      if (res.success){
        console.log(res.data)
        that.backOptions = res.data;
        that.isOpenPayPassword = that.backOptions.length>0?that.backOptions[0].isOpenPayPassword:false;
      }
    });

    queryCashOutLimitMoney().then(res=>{
      if (res.success){
        this.cashOutLimitMoney = res.data;
      }
    });

    queryCashOutPromptStr().then(res=>{
      if (res.success){
        this.cashOutPromptStr = res.data;
      }
    });

    queryUserMoney({b2cUsersId:null}).then(res=>{
      console.log(res.data)
      if (res.success){
        this.queryForm.cashInsidMoney = res.data;
      }
    });
  },
  methods: {
    setOrResetPwd(){
      this.$router.push({path:'/home/bsetcashoutpwd'});
    },
    resetQueryCashoutForm(){
      for(let item in this.queryForm){
        if (typeof this.queryForm[item]==='string'){
          this.queryForm[item]='';
        } else if (this.queryForm[item] instanceof Array) {
          this.queryForm[item]=[];
        } else{
          this.queryForm[item]=null
        }
      }
      this.$forceUpdate();
    },
    submitCashOut(){
      commitCashOutMoney(this.queryForm).then(res=>{
        if (res.success){
          this.$message({message: "提现审核中，请耐心等待", type: 'success'});
          this.resetQueryCashoutForm();
          this.$forceUpdate();
        }
      }).catch(err => {
        this.$message({message: err.message, type: 'error'});
        if (err.code == 401){
          this.$confirm("您还未设置取现密码，现在要去设置吗?")
              .then(_ => {
                this.$router.push({path:'/home/bsetcashoutpwd'});
                //取消新增或修改也要重置表单
              }).catch(err => {this.handleCloseDialog();});
        }
      });
    },
    getData(){
      queryUserMoney({b2cUsersId:null}).then(res=>{
        console.log(res.data)
        if (res.success){
          this.queryForm.cashInsidMoney = res.data;
        }
      });
    }
  }
}
</script>

<style scoped>

</style>
